import {
  SailthruVarsInput,
  useSailthruNewslettersQuery,
  useUpdateSailthruVarsMutation
} from 'api';

import { useAuthenticated } from 'lib/auth';
import { format } from 'date-fns';
import { useEffect } from 'react';
import { forEach } from 'lodash-es';
import { useNewsletterStore } from '../store';

const OPTIN_DATE = format(new Date(), 'yyyy-MM-dd');

export const useSailthruSubscription = ({ source }: { source: string }) => {
  const isLoggedIn = useAuthenticated();
  const { cards, toggleCardSelection, setInitialCards, setCards } =
    useNewsletterStore();
  const [updateSailthruSubscriptions] = useUpdateSailthruVarsMutation();

  const {
    data: user,
    loading: isLoadingUserEmail,
    refetch
  } = useSailthruNewslettersQuery({
    ssr: true,
    skip: !isLoggedIn
  });

  useEffect(() => {
    if (user && !isLoadingUserEmail) {
      const { viewer } = user;
      const { vars } = viewer?.sailthruVars || {};

      const newCards = { ...cards };
      Object.keys(newCards).forEach(key => {
        newCards[key].isSubscribed =
          vars[newCards[key].newsletter_id] === 'true';
      });
      setCards(newCards);
    }
  }, [user, isLoadingUserEmail]);

  const addNewsletterVars = (): SailthruVarsInput[] => {
    const sailthruVars: SailthruVarsInput[] = [];

    forEach(cards, card => {
      const { baseName, isSelected, period, isSubscribed } = card;

      const addSubscriber = isSelected && !isSubscribed;

      if (addSubscriber) {
        sailthruVars.push(
          {
            name: `${baseName}_subscriber`,
            subscribed: addSubscriber
          },
          {
            name: `${baseName}_optin_date`,
            optinDate: addSubscriber ? OPTIN_DATE : null
          },
          { name: `${baseName}_frequency`, frequency: period },
          {
            name: `${baseName}_source`,
            source: addSubscriber ? source : null
          }
        );
      }
    });

    return sailthruVars;
  };

  const onSubscribeSailthruNewsletters = async (email: string) => {
    const sailthruVars = addNewsletterVars();

    await updateSailthruSubscriptions({
      variables: {
        email: email,
        varsData: sailthruVars
      }
    });

    setInitialCards();

    if (isLoggedIn) {
      refetch();
    }
  };

  return {
    toggleCardSelection,
    onSubscribeSailthruNewsletters,
    isLoadingUserEmail,
    userEmail: user?.viewer?.primaryEmailAddress ?? ''
  };
};
